(() => {
  angular
    .module('gm.common.transactions')
    .factory('GmyTransactionInfo', GmyTransactionInfo);

  function GmyTransactionInfo(
    $interpolate,
    $window,
    gettextCatalog
  ) {
    'ngInject';

    const TRANSACTION_METHODS = {
      auto_redemption: gettextCatalog.getString('Automatic Redemption'),
      bonus: gettextCatalog.getString('Bonus'),
      deposit: gettextCatalog.getString('Gold Deposit'),
      fee_ppc: gettextCatalog.getString('Prepaid Card Issue Fee'),
      fee: gettextCatalog.getString('Fee ({{msg}})'),
      gift_received: gettextCatalog.getString('Gold Gift Received from &lt;{{sender}}&gt;'),
      gift_sent: gettextCatalog.getString('Gold Gift Sent to &lt;{{recipient}}&gt;'),
      invoice_paid: gettextCatalog.getString('Invoice Payment Paid to &lt;{{buyer}}&gt;'),
      invoice_requested: gettextCatalog.getString(
        `
        Invoice {{invoiceType !== "request_payment" ? "#" + invoiceNumber : ""}}
        Payment Received from &lt;{{seller}}&gt;
        `
      ),
      network_to_wealth: gettextCatalog.getString('Gold Transfer to Wealth Holding {{holding}}'),
      purchase_code: gettextCatalog.getString('Promotional Code ({{code}})'),
      purchase: gettextCatalog.getString('Gold Purchase'),
      redemption_fee_shipping: gettextCatalog.getString('Gold Redemption Fee (+ Shipping)'),
      redemption_fee: gettextCatalog.getString('Gold Redemption Fee'),
      redemption_shipping: gettextCatalog.getString('Gold Redemption Shipping'),
      redemption: gettextCatalog.getString('Gold Redemption'),
      referral_bonus: gettextCatalog.getString('Referral bonus {{code}}'),
      referred_user:
        gettextCatalog.getString('Referral bonus &lt;{{user_referred}}&gt; ({{reason}})'),
      sale: gettextCatalog.getString('Gold Sale'),
      storage_fee: gettextCatalog.getString('Storage Fee'),
      transfer_received: gettextCatalog.getString('Gold Transfer Received from &lt;{{sender}}&gt;'),
      transfer_sent: gettextCatalog.getString('Gold Transfer Sent to &lt;{{recipient}}&gt;')
    };

    const physical = gettextCatalog.getString('Physical');
    const more = '(items.length > 1 ? ", …" : "")';
    const items = `items[0].quantity + "x " + items[0].description + ${more}`;

    const forcedPayoff = gettextCatalog.getString('"Forced Loan Payoff per Loan Terms"');
    const loanPayoff = gettextCatalog.getString('currency + " Loan Payoff"');

    const loanInitiated = gettextCatalog.getString('Loan Initiated');

    const TRANSACTION_SYSTEMS = {
      ach_ca: gettextCatalog.getString('ACH-CA'),
      ach: gettextCatalog.getString('ACH'),
      altcoin: gettextCatalog.getString('Altcoin'),
      apm: gettextCatalog.getString('{{apm ? apm : "Credit / Debit Card"}}'),
      atm: gettextCatalog.getString('ATM'),
      bonus: gettextCatalog.getString('Bonus'),
      btc: gettextCatalog.getString('{{coin ? "Altcoin: " + coin : "Bitcoin"}}'),
      reason: gettextCatalog.getString('{{reason}}'),
      cc: gettextCatalog.getString('Credit / Debit Card'),
      cup: gettextCatalog.getString('China UnionPay'),
      fee_shipping: gettextCatalog.getString('Fee + Shipping'),
      fee_vault: gettextCatalog.getString('Vault to Vault Fee'),
      fee: gettextCatalog.getString('Fee'),
      gold: gettextCatalog.getString('Gold'),
      interac: gettextCatalog.getString('Interac'),
      latam: gettextCatalog.getString('Latam'),
      loan: gettextCatalog.getString('{{currency}} Maximizer Loan'),
      payoff: `{{forced ? ${forcedPayoff} : ${loanPayoff}}}`,
      paypal: gettextCatalog.getString('PayPal'),
      ph_10g: gettextCatalog.getString('Physical 10g Cubes'),
      ph_1kg: gettextCatalog.getString('Physical 1kg Bars'),
      ph: gettextCatalog.getString('Physical Deposit'),
      physical: `{{items ? ${items} : '${physical}'}}`,
      prepaid: gettextCatalog.getString('Prepaid Card Load'),
      sepa: gettextCatalog.getString('SEPA'),
      shipping: gettextCatalog.getString('Shipping'),
      vault: gettextCatalog.getString('Vault to Vault'),
      wire: gettextCatalog.getString('Wire Transfer')
    };

    const TRANSACTION_TYPES = {
      1: generateType('purchase', 'btc'),
      2: generateType('purchase', 'cup'),
      3: generateType('purchase', 'cc'),
      4: generateType('purchase', 'interac'),
      5: generateType('purchase', 'wire'),
      6: generateType('purchase', 'sepa'),
      7: generateType('purchase', 'atm'),
      8: generateType('sale', 'btc'),
      9: generateType('purchase', 'cc'),
      10: generateType('sale', 'cc'),
      11: generateType('purchase', 'cc'),
      12: generateType('sale', 'wire'),
      13: generateType('sale', 'reason'),
      14: generateType('purchase', 'reason'),
      15: generateType('redemption', 'ph_1kg'),
      16: generateType('redemption', 'ph_10g'),
      17: generateType('transfer_sent'),
      18: generateType('transfer_received'),
      19: generateType('sale', 'prepaid'),
      20: generateType('invoice_requested'),
      21: generateType('invoice_paid'),
      22: generateType('bonus', 'reason'),
      23: generateType('purchase', 'bonus'),
      24: generateType('redemption', 'fee_shipping'),
      25: generateType('redemption', 'fee'),
      26: generateType('redemption', 'shipping'),
      27: generateType('purchase_code'),
      28: generateType('referral_bonus'),
      29: generateType('referred_user'),
      30: generateType('fee_ppc'),
      31: generateType('purchase', 'ach'),
      33: generateType('auto_redemption'),
      34: generateType('deposit', 'vault'),
      35: generateType('redemption', 'vault'),
      36: generateType('redemption', 'fee_vault'),
      37: generateType('sale', 'sepa'),
      38: generateType('purchase', 'apm'),
      40: generateType('redemption', 'physical'),
      41: generateType('purchase', 'ach'),
      42: generateType('sale', 'ach'),
      43: generateType('purchase', 'ach_ca'),
      44: generateType('sale', 'ach_ca'),
      46: generateType('purchase', 'altcoin'),
      48: generateType('purchase', 'cc'),
      49: generateType('purchase', 'interac'),
      50: generateType('purchase', 'loan'),
      51: generateType('sale', 'payoff'),
      52: generateType('purchase', 'paypal'),
      53: generateType('sale', 'paypal'),
      54: generateType('network_to_wealth'),
      57: generateType('purchase', 'latam'),
      58: generateType('purchase', 'apm'),
      59: generateType('purchase', 'apm'),
      60: generateType('purchase', 'apm'),
      98: generateType('storage_fee'),
      99: generateType('fee'),
      100: 'Chargeback - {{msg}} - {{chargedBackTx}}'
    };

    const SEND_PAYMENT = 17;
    const RECEIVE_PAYMENT = 18;
    const LOAN = 50;
    const PAYOFF = 51;
    const FEE = 99;
    const CHARGEBACK_ID = 100;

    return {
      getBitcoinCauseId,
      getTransactionCauseDescription,
    };

    function generateType(m, s) {
      return TRANSACTION_METHODS[m] + (
        s && TRANSACTION_SYSTEMS[s]
          ? ` (${TRANSACTION_SYSTEMS[s]})`
          : ''
      );
    }

    function getBitcoinCauseId() {
      return 1;
    }

    function getTransactionCauseDescription(tx) {
      if (tx.causeId === CHARGEBACK_ID && tx.metadata && tx.metadata.causeId) {
        tx.metadata.chargedBackTx = getTransactionCauseDescription(tx.metadata);
      }

      if (tx.causeId === LOAN || tx.causeId === PAYOFF) {
        if (!tx.metadata) {
          tx.metadata = {};
        }
        tx.metadata.currency = tx.causeCurrency;
      }

      let info = TRANSACTION_TYPES[tx.causeId];

      if (tx.causeId === FEE && tx.metadata && tx.metadata.metadata) {
        const originalTrade = tx.metadata.metadata;
        if (originalTrade.loanId) {
          info = `{{msg}} ({{currency}} ${loanInitiated} {{date|gmFormatDate}})`;
          tx.metadata.currency = tx.causeCurrency;
          tx.metadata.date = $window.moment(originalTrade.openedAt, 'YYYY-MM-DD').valueOf();
        }
      }

      if (tx.causeId === SEND_PAYMENT && tx.metadata && tx.metadata.subType === 'gift') {
        info = generateType('gift_sent');
      }

      if (tx.causeId === RECEIVE_PAYMENT && tx.metadata && tx.metadata.subType === 'gift') {
        info = generateType('gift_received');
      }

      try {
        return $interpolate(info)(tx.metadata || {});
      } catch (e) {
        return '';
      }
    }
  }
})();
